<div class="modal-header">
    <div class="card-footer  d-flex justify-content-between px-0 py-3">
        <div>
            <button type="button" class="btn font-weight-bold btn-sm btn-primary mr-2" (click)="uploadDocument()"> 
                <i class="fas fa-plus icon-sm"></i>Add Document
            </button>
        </div>  
    </div>
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
        <i aria-hidden="true" class="ki ki-close"></i>
    </button>
</div>
<div class="modal-body" >
    <div style="max-height: 70vh;overflow-y: auto;">
        <form class="form" #formSearch="ngForm">
        <table  class="table table-bordered table-sm rounded" >
            <thead>
                <tr>
                    <th scope="col"><input class="form-control" type="text" [(ngModel)]="txtDocument_Name" name="txtDocument_Name"></th>
                    <th scope="col"><select class="form-control" [(ngModel)]="txtDocument_Type" name="_txtDocument_Type">
                        <option value="all">All Documents</option>
                        <option value="image">Image</option>
                        <option value="pdf">PDF</option>
                        <option value="Other">Other</option>
                    </select></th>
                    <th scope="col" width="30%"><input class="form-control" type="text" [(ngModel)]="txtDocument_Note" name="_txtDocument_Note"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col" width="15%">
                        <div style="text-align: right;">
                            <button type="submit" class="btn btn-success font-weight-bold ml-0" (click)="search()">
                                <i class="la la-search"></i>Search
                            </button>
                            <button type="button" class="btn btn-light ml-3" id="kt_reset" (click)="reset()">
                                <i class="la la-close"></i>Reset
                            </button>
                        </div>
                    </th>
                </tr>
                <tr>                    
                    <th scope="col">Document Name</th>
                    <th scope="col">Document Type</th>
                    <th scope="col">Document Note</th>
                    <th scope="col">Created By</th>
                    <th scope="col">Created On</th>
                    <th scope="col">Action</th>
                </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of documentService.documents" >
                <td> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-tag-fill mr-1" viewBox="0 0 16 16">
                    </svg> {{item.document_name}}
                </td>
                <td>{{item.document_type}}</td>
                <td>{{item.document_note}}</td>
                <td>{{item.created_by}}</td>
                <td>{{item.created_on}}</td>
                <td>
                    <div class="btn-group">
                        <button type="button" class="btn btn-icon btn-secondary btn-sm m-1" (click)="viewDocument(item)">
                            <i class="las la-book"></i>
                        </button>
                        <button type="button" class="btn btn-icon btn-secondary btn-sm m-1" (click)="edit(item)">
                            <i class="la la-pen"></i>
                        </button>
                        <button type="button" class="btn btn-icon btn-secondary btn-sm btn-danger m-1" (click)="delete(item)">
                            <i class="la la-trash"></i>
                        </button>
                    </div>
                </td>
            </tr> 
            </tbody>
        </table>
    </form>
    </div>

</div>  
<div class="modal-footer">                               
    <button type="button" class="btn font-weight-bold btn-secondary ml-3" data-bs-dismiss="modal" aria-label="Close">
        Exit
    </button> 
</div>